import Vue from 'vue';
import vueApexCharts from 'vue-apexcharts'

Vue.use(vueApexCharts)

Vue.component('apexchart',vueApexCharts)